export default __webpack_public_path__ + "static/media/my-loc.9ac2e330.png";